import { Component } from '@angular/core';

import { AppURL } from 'src/app/app.url';

import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConvertService } from 'src/app/services/convert.service';
import { environment } from 'src/environments/environment';
import { BasketItems, CreateSystem, System } from '../package/package';

@Component({
  selector: 'app-secret-key',
  templateUrl: './secret-key.component.html',
  styleUrls: ['./secret-key.component.scss']
})
export class SecretKeyComponent {
  constructor(private router: Router,
    private http: HttpClient,
    private con: ConvertService) {
    if (localStorage.getItem('basket')) {
      let model: any = localStorage.getItem('basket')
      JSON.parse(model).forEach((f: BasketItems) => {
        this.actionOrders.push(f)
      })
    }
    this.getSystem()
  }
  actionOrders: any[] = [];
  package: any = [] = [
    { logo: '../assets/logo/POS_0.png', name: 'POS', url: '', status: false },
    { logo: '../assets/logo/Booking X_0.png', name: 'Booking', url: '', status: false },
    { logo: '../assets/logo/NLChat_0.png', name: 'NLChat', url: '', status: false },
    { logo: '../assets/logo/Biz soft_0.png', name: 'Bizsoft', url: '', status: false },
    { logo: '../assets/logo/SURVEY BOX_0.png', name: 'Survey', url: '', status: false },
    { logo: '../assets/logo/DeeAuction_0.png', name: 'DeAuction', url: '', status: false },
  ]

  SystemItems!: System[]
  getSystem() {
    this.http.get(`system`).subscribe({
      next: (res: any) => {
        this.SystemItems = res.data
        this.SystemItems.forEach(f => {
          if (f.System_logo) f.System_logo = environment.contentPackage + f.System_logo
        })
      }
    })
  }


  viewPackage!: System;
  viewItem: boolean = false
  view(item: System) {
    this.viewPackage = item
    if (this.viewPackage.System_status == 1) this.router.navigate(['/', AppURL.secretkey, item.System_id])
    if (this.viewPackage.System_status == 2) this.router.navigate(['/', AppURL.secretkey, 'otp', item.System_id])
  }





}
